// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var SharingProfileMiniFormProfilePhoto = require("../../reason/settings/components/avatarField/SharingProfileMiniFormProfilePhoto.bs.js");
var ProfilePageProfilePhotoForm_agent_graphql = require("../../__generated__/ProfilePageProfilePhotoForm_agent_graphql.bs.js");

var convertFragment = ProfilePageProfilePhotoForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageProfilePhotoForm_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageProfilePhotoForm(props) {
  var agent = use(props.agent);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Change Your Profile Photo",
                      className: "text-2xl border-b pb-4 font-semibold"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Upload a photo to show on your Top Agent Network profile.",
                              className: ""
                            }),
                        JsxRuntime.jsx(SharingProfileMiniFormProfilePhoto.make, {
                              agent: agent.fragmentRefs
                            })
                      ],
                      className: ""
                    })
              ],
              className: "flex flex-col space-y-4"
            });
}

var make = ProfilePageProfilePhotoForm;

exports.AgentFragment = AgentFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
